<template>
  <div>
    <top-header :type="6" :placeholder="'严选好房'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem" />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="">
        </div>
        <div class="list_con new_list">
          <div class="inner m_flex_box flex_vc" v-for="(item, index) in list" :key="index"
            @click="toDetail(item.id, item.old)">
            <img v-show="item.xmfm" class="banner" v-lazy="item.xmfm">
            <img v-show="!item.xmfm" class="banner" src="@/assets/img/default_house_list.jpg">
            <div class="new_r">
              <div class="m_flex_box flex_vc flex_jz tit">
                <h4 class="line_comp1">{{ item.tgmc }}</h4>
                <i>在售</i>
              </div>
              <p class="line_comp1 col_gray">{{ item.xmdz ? item.xmdz : '暂无地址信息' }}</p>
              <div class="m_flex_box flex_jz flex_vc">
                <div class="m_flex_box flex_vc info">
                  <p>未售套数：<span>{{ item.wsts ? item.wsts : '0' }}</span></p>
                  <p>访问量：{{ item.fwl | format }}</p>
                </div>
                <a @click.stop="callTo(item.zxdh, 3, item.id)" class="tel"><img src="@/assets/img/tel.png" alt=""></a>
              </div>
              <div class="m_flex_box flex_jz flex_vc">
                <div class="col_red m_flex_box flex_vb">
                  <h4>{{ item.xsjg }}</h4><span v-show="item.xsjg !== '暂无'">元/平</span>
                </div>
                <p v-if="item.ksts" class="m_flex_box flex_vc text">
                  <span @click.stop @click="toOneHouseOnePrice(item.id)">一房一价</span>
                  <van-icon name="play" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header';
import slideImg from '@/components/slideImg'
export default {
  name: 'yanxuanList',
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      timer: null,
      listPage: 1,
      lx: '00'
    };
  },
  components: {
    topHeader,
    slideImg
  },
  filters: {
    format(param) {
      if (param >= 10000) {
        return (param / 10000).toFixed(2) + 'w'
      } else {
        return param
      }
      // var str = param;
      //
      // if (param.length > 4) {
      //   //获取万位长度字符串
      //   var str1 = str.substring(0, str.length - 4);
      //   var str2 = str.substring(str1.length, 1);
      //   var str3;
      //   if (str2.length == 0) {
      //      str3 = str1 + "." + 0;
      //   } else {
      //      str3 = str1 + "." + str2;
      //   }
      //   return str3;
      // } else {
      //   var str6 = str.substring(0, 1);
      //   var str7 = "0." + str6;
      //   return str7;
      // }
    }
  },
  mounted() { },
  methods: {
    callTo(phone, lx, infoId) {
      if (!phone) {
        this.$dialog.alert({
          title: '提示',
          message: '暂无可拨打电话'
        });
        return;
      }
      this.$new.post('telTj/addTeltj.do', qs.stringify({
        phone,
        lx,
        infoId
      })).then(res => {
        window.location.href = `tel:${phone}`
      })
    },
    toDetail(itemId, old) {
      var paths = '/projectDetail';
      if (old) {
        if (old !== '0') {
          paths = '/projectDetailIndex';
        }
      } else {
        paths = '/projectDetail';
      }
      this.$router.push({
        path: paths,
        query: { itemId }
      })
    },
    toOneHouseOnePrice(itemId) {
      this.$router.push({
        path: '/oneHouseOnePrice',
        query: { itemId }
      })
    },

    onRefresh() {
      this.listPage = 1;
      this.finished = false;
      this.loading = false,
        this.list = [];
      this.onLoad(1);
    },

    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$request.get("erpService/yw/api/customer/boutiqueList?pageNo=" + this.listPage + '&pageSize=10').then(res => {
          if (type) {
            this.isLoading = false;
          }
          this.loading = false;
          if (res.code == '200') {
            if (res.result.length) {
              this.list = this.list.concat(res.result)
              this.loading = false;
              this.listPage += 1;
            } else {
              this.isLoading = false;
              this.finished = true;
            }
          } else {
            this.isLoading = false;
            this.finished = true;
          }
        })
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'ProjectDetail' || to.name === 'ProjectDetailIndex') {
      this.$store.dispatch('saveView', ['RecommendList']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
.pad_t {
  padding-top: 1.1rem;
}

.tab_con {
  padding: 0.24rem 0.23rem;
  position: fixed;
  left: 0;
  right: 0;
  top: 0.9rem;
  z-index: 2;
  font-size: 0.26rem;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;

  span {
    background-color: #F4F5F8;
    line-height: 0.58rem;
    width: 2.1rem;
    text-align: center;
    border-color: #F4F5F8;
    border-width: 1px;
    border-style: solid;
    border-radius: 0.29rem;

    &.active {
      color: #2F72F5;
      border-color: #2F72F5;
      background-color: #F0F5FF;
    }
  }
}

.list_con {
  margin: 0.05rem auto 0;
  width: 7.04rem;

  .inner {
    padding: 0.35rem 0;
    border-bottom: 1px solid #F4F4F4;
  }

  .banner_con {
    width: 2.44rem;
    height: 1.84rem;
    position: relative;

    .rank {
      background-color: #404040;
      color: #fff;
      width: 0.8rem;
      line-height: 0.38rem;
      border-radius: 0 0.08rem 0 0.08rem;
      font-size: 0.22rem;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;

      &.before {
        background-color: #FF342A;
      }
    }
  }

  .banner {
    width: 2.44rem;
    height: 1.84rem;
    display: block;
  }

  .new_r {
    .col_gold {
      font-size: 0.24rem;
      color: #AF6E20;
      margin-bottom: 0.1rem;
    }

    img {
      width: 100%;
    }

    width: 4.25rem;
    margin-left: 0.3rem;

    .col_gray {
      font-size: 0.24rem;
      color: #505050;
    }

    .tit {
      h4 {
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 3rem;
      }

      i {
        //width: 0.6rem;
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2F72F5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }

      span {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24D064;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
    }
  }
}

.new_list {
  .inner {
    .new_r {
      .col_gray {
        margin: 0.1rem 0;
      }

      .info {
        color: #505050;
        font-size: 0.24rem;

        p {
          margin-right: 0.2rem;
        }

        span {
          color: #FF6A18;
        }
      }

      .col_red {
        margin-top: 0.1rem;

        h4 {
          font-size: 0.36rem;
          font-weight: 800;
        }

        span {
          font-size: 0.22rem;
        }
      }

      .text {
        margin-top: 0.1rem;
        font-size: 0.22rem;
        color: #A0A0A0;

        i {
          font-size: 0.18rem;
        }
      }

      .tel {
        width: 0.36rem;
        height: 0.36rem;
      }
    }
  }
}
</style>